var _circle, _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAutomate = function SvgAutomate(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 22,
    r: 20,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0548 22.8202L27.3362 13.5388M18.1676 23.1101L20.4907 29.0838C20.6954 29.61 20.7977 29.8732 20.9451 29.95C21.0729 30.0166 21.2252 30.0167 21.3531 29.9502C21.5006 29.8736 21.6033 29.6106 21.8085 29.0846L27.634 14.1568C27.8193 13.682 27.9119 13.4446 27.8613 13.2929C27.8173 13.1611 27.7139 13.0577 27.5821 13.0137C27.4304 12.9631 27.193 13.0557 26.7182 13.241L11.7904 19.0665C11.2644 19.2717 11.0014 19.3744 10.9248 19.5219C10.8583 19.6498 10.8584 19.8021 10.925 19.9299C11.0018 20.0773 11.265 20.1796 11.7912 20.3843L17.7649 22.7074C17.8717 22.7489 17.9251 22.7697 17.9701 22.8018C18.0099 22.8302 18.0448 22.8651 18.0732 22.9049C18.1053 22.9499 18.1261 23.0033 18.1676 23.1101Z",
    stroke: "var(--hyperlink )",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7496 23.1008C40.0965 29.2406 36.6197 34.9941 30.8666 38.3177C21.3083 43.8395 9.08604 40.5626 3.56752 30.9986L2.97975 29.9799M1 18.8992C1.65314 12.7594 5.12992 7.00585 10.883 3.68232C20.4414 -1.83948 32.6636 1.4374 38.1821 11.0014L38.7699 12.0201M40.4452 8.33651L40.0149 9.94329L39.1544 13.1569L35.9427 12.2958L34.3369 11.8653M7.41409 30.1348L5.80826 29.7043L2.5966 28.8432L1.73604 32.0567L1.30575 33.6635",
    stroke: "#1D2026",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAutomate, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/automate.193d3a2f.svg";
export { ForwardRef as ReactComponent };